import { getRewardList } from '@/api/system.api.js'

import cookies from '@/utils/cookie'
import { isMobile, getSign } from '@/utils/common.js'

import { mapActions, mapMutations } from 'vuex'

export default {
  data() {
    return {
      videoSrc: '',
      reserveCount: '', // 预约人数
      newsPicList: [],
      characterList: [],
      reservationGiftsData: {},
      downloadGiftsData: {},
      invitationGiftsData: {},
      invitationGiftsLog: [],
      featureList: [],
      reserveDialogVisible: false,
      ruleDialogVisible: false,
      activityRule: '',
    }
  },
  computed: {
    stage() {
      return this.$store.getters.stage
    },
    user() {
      return this.$store.getters.user
    },
    isLogin() {
      return Object.keys(this.user).length > 0
    },
    isReserved() { // 是否已预约
      return this.$store.isReserved
    },
  },
  async created() {
    await this.getUserInfo()
    await this.getHomeInfo()
    await this.getGiftData()

    const showReserve = this.$route.params.showReserve
    if (showReserve) this.openReserveDialog()

    // this.handleDevEnv()
  },
  methods: {
    ...mapActions(['getHomeData']),
    ...mapMutations(['setUser', 'setInviteCount', 'setIsReserved', 'setStage', 'setLoginDialog', 'setDownloadUrl']),
    // 从cookie中获取用户信息
    async getUserInfo() {
      const userInfo = cookies.get('cqytj', 'userInfo')
      if (userInfo) this.setUser(JSON.parse(userInfo))
    },
    // 获取首页数据
    async getHomeInfo() {
      const homeData = await this.getHomeData()

      this.videoSrc = homeData.videoSrc
      this.newsPicList = homeData.newsPicList
      this.characterList = homeData.characterList
      this.featureList = homeData.featureList
    },
    // 获取奖励数据
    async getGiftData() {
      const params = {}
      if (this.isLogin) {
        params.token = this.user.token
      } else {
        params.game = 'tc'
      }
      params.sign = getSign(params)
      await getRewardList(params)
        .then((res) => {
          if (res.code == 0) {
            const user = res.data.user ? res.data.user : {}
            if (user[1]) {
              this.reserveCount = user[1].num
              this.setIsReserved(user[1].status)
            }
            if (user[2]) {
              // 预约阶段
              this.setInviteCount({ invite: user[2].num })
            }
            if (user[3]) {
              // 下载阶段
              this.setInviteCount({ download: user[3].num })
            }

            if (res.data.rewardLog) {
              this.invitationGiftsLog = []
              for (let type in res.data.rewardLog) {
                if (type == 2 || type == 3) { // 邀请预约和邀请下载
                  for (let i in res.data.rewardLog[type]) {
                    res.data.rewardLog[type][i]['type'] = type
                    this.invitationGiftsLog.push(res.data.rewardLog[type][i])
                  }
                }
              }
            }

            const rewards = res.data.reward
            const rewardType = res.data.rewardType

            if (rewardType[2]) {
              // 预约阶段
              this.setStage(0)
            } else if (rewardType[3]) {
              // 下载阶段
              this.setStage(1)
              this.setDownloadUrl(rewardType[3].android)
            }
// // 暂时固定为预约阶段
// this.setStage(0)

            if (rewardType['1']) {
              const reservationGifts = []
              let count = 0
              for (let i in rewards['1']) {
                if (count < 4) {
                  reservationGifts.push(rewards['1'][i])
                  count++
                }
              }
              this.reservationGiftsData = {
                list: reservationGifts,
                rule: rewardType['1'].rule
              }
            }

            if (rewards['6']) {
              const downloadGifts = []
              let count = 0
              for (let i in rewards['6']) {
                const giftIcon = rewards['6'][i]['icon'].split(',')
                const giftName = rewards['6'][i]['rewardName'].split('，')
                for (let j in giftName) {
                  downloadGifts.push({
                    name: giftName[j],
                    icon: giftIcon[j],
                  })
                }
                count++
              }
              this.downloadGiftsData = {
                list: downloadGifts,
                rule: rewardType['6'].rule
              }
            }

            if (this.stage == 0) {
              const invitationGifts = []
              let count = 0
              for (let i in rewards['2']) {
                if (count < 3) {
                  invitationGifts.push(rewards['2'][i])
                  count++
                }
              }
              this.invitationGiftsData = {
                list: invitationGifts,
                rule: rewardType['2'].rule
              }
            } else if (this.stage == 1) {
              const invitationGifts = []
              let count = 0
              for (let i in rewards['3']) {
                if (count < 3) {
                  invitationGifts.push(rewards['3'][i])
                  count++
                }
              }
              this.invitationGiftsData = {
                list: invitationGifts,
                rule: rewardType['3'].rule
              }
            }
          }
        })
    },
    // 打开预约窗口
    openReserveDialog() {
      // this.reserveDialogVisible = true
      this.setLoginDialog({ visible: true })
    },
    // 打开活动规则窗口
    openRuleDialog(text) {
      this.activityRule = text
      this.ruleDialogVisible = true
    },
    handleDevEnv() {
      // const reservationImg = [
      //   require('@/assets/img/pc/dev/reservation_gift1.png'),
      //   require('@/assets/img/pc/dev/reservation_gift2.png'),
      //   require('@/assets/img/pc/dev/reservation_gift3.png'),
      //   require('@/assets/img/pc/dev/reservation_gift4.png'),
      // ]
      // for (let i in this.reservationGiftsData.list) {
      //   this.reservationGiftsData.list[i].icon = reservationImg[i]
      // }

      // const downloadImg = [
      //   require('@/assets/img/pc/dev/download_gift1.png'),
      //   require('@/assets/img/pc/dev/download_gift2.png'),
      // ]
      // for (let i in this.downloadGiftsData.list) {
      //   this.downloadGiftsData.list[i].icon = downloadImg[i]
      // }

      // const invitationImg = [
      //   require('@/assets/img/pc/dev/invitation_gift1.png'),
      //   require('@/assets/img/pc/dev/invitation_gift2.png'),
      //   require('@/assets/img/pc/dev/invitation_gift3.png'),
      // ]
      // for (let i in this.invitationGiftsData.list) {
      //   this.invitationGiftsData.list[i].icon = invitationImg[i]
      // }

      // const characterImg = [
      //   require('@/assets/img/pc/dev/character01.png'),
      //   require('@/assets/img/pc/dev/character02.png'),
      //   require('@/assets/img/pc/dev/character03.png'),
      //   require('@/assets/img/pc/dev/character04.png'),
      // ]
      // const avatarImg = [
      //   require('@/assets/img/pc/dev/avatar01.png'),
      //   require('@/assets/img/pc/dev/avatar02.png'),
      //   require('@/assets/img/pc/dev/avatar03.png'),
      //   require('@/assets/img/pc/dev/avatar04.png'),
      // ]
      // const avatarActiveImg = [
      //   require('@/assets/img/pc/dev/avatar01_active.png'),
      //   require('@/assets/img/pc/dev/avatar02_active.png'),
      //   require('@/assets/img/pc/dev/avatar03_active.png'),
      //   require('@/assets/img/pc/dev/avatar04_active.png'),
      // ]
      // for (let i in this.characterList) {
      //   this.characterList[i].img = characterImg[i]
      //   this.characterList[i].avatar_inactive = avatarImg[i]
      //   this.characterList[i].avatar_active = avatarActiveImg[i]
      // }

      // const featureImg = [
      //   require('@/assets/img/pc/banner_bg.jpg'),
      // ]
      // for (let i in this.featureList) {
      //   if (i % 2 != 0) this.featureList[i].url = featureImg[0]
      // }
    }
  },
}